import { Select } from 'antd';
import React from 'react';
import { SelectProps } from 'antd/lib/select';
import { SequenceTypesIds } from 'types';
import { testId } from 'leash/utilities/test/dataTestId';

const { Option } = Select;

const sequenceTypes = [
  {
    id: 1,
    name: 'Ground transportation',
  },
  {
    id: 2,
    name: 'Flight',
  },
  {
    id: 3,
    name: 'Transporter',
  },
  {
    id: 4,
    name: 'Meetup',
  },
  {
    id: 5,
    name: 'Chaperone',
  },
];

export function SelectType({
  onChange,
  defaultValue,
  disabled = false,
}: SelectProps<SequenceTypesIds>) {
  return (
    <Select
      defaultValue={defaultValue}
      onChange={onChange}
      placeholder="Please select the sequence type..."
      disabled={disabled}
      data-testid={testId.sequenceTypeSelect}
    >
      {sequenceTypes.map((t: { id: number; name: string }) => {
        return (
          <Option
            value={t.id}
            key={t.id}
            data-testid={testId.sequenceTypeOptions(t.name)}
          >
            {t.name}
          </Option>
        );
      })}
    </Select>
  );
}
